import {PrincipalUtil} from "modules/utils/PrincipalUtil";

export class SettingsResolver {
    static instance = [
        () => PrincipalUtil.getSettings()
    ]

    static smsResolverInstance = [
        () => PrincipalUtil.getSmsSettings()
    ]
}
